module.exports = __webpack_public_path__ + "static/media/warning.0bf1b149.svg";